<div
  fxLayout="row"
  fxLayoutAlign="center center"
  class="filter-form-container"
>
  <form>
    <div
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="center center"
      class="buttons-wrapper"
    >
      <a
        *ngFor="let roomCount of [null, '2', '3']"
        mat-raised-button
        color="main-color"
        [class.active]="getPropertySearch().room_count == roomCount"
        (click)="getPropertySearch().room_count = roomCount; refreshApartmentTypes();"
      >
        {{ 'pages.houses.room_filters.' + (roomCount ? roomCount : '0') | translate }}
      </a>
    </div>
  </form>
</div>

<div
  class="properties"
  id="list"
  (window:scroll)="onScroll()"
  #section
>
  <div
    *ngIf="apartmentTypes.length == 0 && !apiLoading"
  >
    {{ 'others.apartments.no_length' | translate }}
  </div>
  <div
    fxLayout="column"
    fxLayout.gt-xs="row wrap"
    fxLayoutAlign="center center"
    class="properties-list"
    *ngIf="apartmentTypes.length"
  >
    <a
      *ngFor="let apartmentType of apartmentTypes"
      class="property-item"
      [routerLink]="[basePath, 'tip-apartament', apartmentType.friendly_id]"
    >
      <app-my-apartment-type [apartmentType]="apartmentType"></app-my-apartment-type>
    </a>
  </div>
  <app-loading-spinner
    [apiLoading]="apiLoading"
  >
  </app-loading-spinner>
  <app-scroll-guide
    [conditions]="apartmentTypes && apartmentTypes.length && !endOfList && !apiLoading"
  >
  </app-scroll-guide>
</div>



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.html